import { ErrorCardField } from './types';

/**
 * What an error card is about: the declaration, one item, or several. Items are named by their number
 * today, so the title matches the products table; an item deleted since the rejection has none.
 */
const getErrorCardTitle = (fields: ErrorCardField[]): string => {
    const items = fields.flatMap(({ item }) => (item ? [item] : []));
    if (!items.length) return 'Declaration';

    const itemNumbers = Array.from(
        new Set(items.flatMap(({ itemNumberToday }) => (itemNumberToday ? [itemNumberToday] : [])))
    ).sort((a, b) => a - b);
    const hasDeletedItem = items.some(({ itemNumberToday }) => !itemNumberToday);

    if (itemNumbers.length === 1 && !hasDeletedItem) return `Item ${itemNumbers[0]}`;
    if (!itemNumbers.length) return 'Deleted item';

    const names = [...itemNumbers.map(String), ...(hasDeletedItem ? ['deleted item'] : [])];
    return `Items ${names.join(', ')}`;
};

export default getErrorCardTitle;
